import { render } from "./EditTopic.vue?vue&type=template&id=6b37b91c&scoped=true"
import script from "./EditTopic.vue?vue&type=script&lang=js"
export * from "./EditTopic.vue?vue&type=script&lang=js"

import "./EditTopic.vue?vue&type=style&index=0&id=6b37b91c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b37b91c"]])

export default __exports__